module.exports = __webpack_public_path__ + "img/vantagens.af58b9ff.png";